export default defineAppConfig({
  ui: {
    button: {
      slots: {
        base: "cursor-pointer",
      },
      variants: {
        color: {
          primary: "",
        },
        variant: {
          solid: "",
          outline: "",
          ghost: "",
          soft: "",
          link: "",
          subtle: "",
        },
        size: {
          xs: {
            base: "px-3.5 py-1 gap-1 rounded-md text-xs",
            leadingIcon: "size-4",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-4",
          },
          sm: {
            base: "px-4 py-2 gap-1.5 rounded-md-1.5 text-xs",
            leadingIcon: "size-4",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-4",
          },
          md: {
            base: "px-5.5 py-2.5 gap-1.5 rounded-md-1.5 text-sm",
            leadingIcon: "size-5",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-5",
          },
          lg: {
            base: "px-5.5 py-3.5 gap-2 rounded-md text-md",
            leadingIcon: "size-5",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-5",
          },
          xl: {
            base: "px-6 py-4 gap-2 rounded-md text-base",
            leadingIcon: "size-6",
            leadingAvatarSize: "xs",
            trailingIcon: "size-6",
          },
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: "solid",
          class:
            "bg-primary-800 hover:bg-primary-900 border-primary-800 text-primary-50 dark:bg-primary-700 dark:hover:bg-primary-600 dark:border-primary-700 dark:text-primary-50",
        },
        {
          color: "primary",
          variant: "outline",
          class:
            "bg-transparent text-primary-950 border-primary-400 hover:bg-primary-100 dark:bg-transparent dark:text-primary-100 dark:border-primary-600 dark:hover:bg-primary-800/50",
        },
        {
          color: "primary",
          variant: "ghost",
          class:
            "bg-transparent border-transparent text-primary-800 hover:bg-primary-200 dark:bg-transparent dark:border-transparent dark:text-primary-200 dark:hover:bg-primary-800/40",
        },
        {
          color: "primary",
          variant: "soft",
          class:
            "bg-primary-200/80 border-primary-300 text-primary-800 hover:bg-primary-300 dark:bg-primary-900 dark:border-primary-900 dark:text-primary-100 dark:hover:bg-primary-900/50",
        },
        {
          color: "primary",
          variant: "link",
          class:
            "bg-transparent border-transparent text-primary-800 hover:text-primary-900 hover:underline dark:bg-transparent dark:border-transparent dark:text-primary-200 dark:hover:text-primary-100",
        },
        {
          color: "primary",
          variant: "subtle",
          class:
            "bg-transparent border-transparent text-primary-800 hover:bg-primary-100 dark:bg-transparent dark:border-transparent dark:text-primary-200 dark:hover:bg-primary-900/50",
        },
      ],
    },
  },
});
